import { useRef } from 'react';
import { CustomDialog, CustomDialogTitle, hide, show } from './custom_dialog';

// 金舜达 银盛支付 确认支付弹窗 主要用于跳转小程序按钮创建
interface ConfirmDialogProps {
  miniPath: string;
  miniOrgId: string;
  miliPaLink: string;
}
interface Props extends ConfirmDialogProps {
  onCancel: () => void;
  onFailure: () => void;
  onConfirm: () => void;
}
function ConfirmDialog({ miniPath, onCancel, miniOrgId, onConfirm, onFailure, miliPaLink }: Props) {
  const ref = useRef<HTMLElement>();

  function handleRef(e: HTMLElement) {
    ref.current = e;
    ref.current?.removeEventListener('ready', readyHandel);
    ref.current?.removeEventListener('launch', launchHandel);
    ref.current?.removeEventListener('error', errorHandel);
    ref.current?.addEventListener('ready', readyHandel);
    ref.current?.addEventListener('launch', launchHandel);
    ref.current?.addEventListener('error', errorHandel);
  }

  async function launchHandel(e: any) {
    console.log('跳转小程序成功：', e.detail);
    onConfirm();
  }

  function errorHandel(e: any) {
    console.log('跳转小程序失败：', e.detail);
    onFailure();
  }

  function readyHandel() {
    console.log('跳转小程序准备完成');
  }

  // @ts-ignore
  return (
    <CustomDialog maskClose={false} onClose={() => {}}>
      <CustomDialogTitle title="温馨提示" showCloseIcon={false} onClose={onCancel} />
      <div className="confirm-content">即将跳转到小程序，请在小程序内支付</div>
      <div className="custom-bottom">
        <div className={`action`} onClick={onCancel}>
          取消
        </div>
        <div className={`action primary border-left wx-btn-block`}>
          {/* @ts-ignore */}
          <wx-open-launch-weapp
            ref={handleRef}
            id="launch-btn"
            class="wx-btn"
            username={miniOrgId}
            path={`${miniPath}?businessData=${miliPaLink}`}
          >
            <script type="text/wxtag-template">
              <div
                style={{
                  width: '100vw',
                  height: '100vh',
                  background: '#fff',
                  display: 'flex',
                  border: 'none',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 9999999,
                  borderRadius: '0 0 10px 0',
                  color: '#6571ff',
                }}
              >
                打开小程序
              </div>
            </script>
            {/* @ts-ignore */}
          </wx-open-launch-weapp>
          立即跳转
        </div>
      </div>
    </CustomDialog>
  );
}
export default async function showJSDConfirmPayDialog(props: ConfirmDialogProps) {
  return new Promise<number>((resolve, reject) => {
    show(
      <ConfirmDialog
        {...props}
        onCancel={() => {
          hide();
          resolve(0);
        }}
        onConfirm={() => {
          hide();
          resolve(1);
        }}
        onFailure={() => {
          hide();
          resolve(2);
        }}
      />
    );
  });
}
